import { SubjectFragment, SubjectsDocument, SubjectsQuery, SubjectsQueryVariables } from '../types';
import { client } from '../../client';

// [Shared] Get subjects
export async function getSubjects(): Promise<SubjectsQuery> {
  try {
    const result = await client.query<SubjectsQuery, SubjectsQueryVariables>({
      query: SubjectsDocument,
    });
    return result.data;
  } catch (error) {
    throw Error(error);
  }
}
